import React from "react";

const solutions = [
  "Enterprise ecommerce stores",
  "B2B wholesale portals",
  "Multi-store environments",
  "International ecommerce websites",
  "Multi-language stores",
  "Multi-currency stores",
  "High-volume online stores",
  "Subscription ecommerce stores",
  "Custom Shopify Plus websites",
];

export default function Section4() {
  return (
    <div className="w-full Section4 px-5 md:px-0 pt-[2%]">
      <div className="flex flex-col-reverse items-center w-full md:flex-row justify-evenly section4-container gap-y-8">
        <div className="w-full md:w-auto">
          <img
            src="../../../assets/computer-shopify.png"
            alt="Shopify Plus Development Store Solutions"
            className="w-full md:w-auto cover"
          />
        </div>

        <div className="w-full md:w-[42%] text-[#373737]">
          <h2 className="text-[26px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#DA2128] my-[0.67em] pb-[2%]">
            Shopify Plus Development Store Solutions
          </h2>
          <p className="leading-[22px] pb-[1%] text-sm md:text-base mb-5 font-open">
            Every business has different requirements. Some need advanced
            checkout customization. Others require ERP integrations,
            automation, or international storefronts.
          </p>
          <p className="leading-[22px] pb-[1%] text-sm md:text-base mb-5 font-open">
            Our Shopify Plus development store solutions tackle real business
            problems. We do not add extra features for no reason.
          </p>
          <p className="leading-[22px] text-sm md:text-base mb-3 font-open font-bold text-[#151515]">
            We help businesses build:
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 mb-5">
            {solutions.map((item) => (
              <li key={item} className="flex items-start text-sm md:text-base font-open">
                <span className="text-[#DA2128] text-lg leading-[20px] mr-2">•</span>
                {item}
              </li>
            ))}
          </ul>
          <p className="leading-[22px] text-sm md:text-base font-open">
            Every project starts with understanding your business objectives
            before planning the technical solution.
          </p>
        </div>
      </div>
      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}